import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { ButtonWithLoader } from '../../../../ui/components/Button/ButtonWithLoader';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import {
	Dialog,
	DialogMain,
	StyledDialogCloseButton,
} from '../../../shared/components/dialog';
import { CancelIcon, TextButton } from '../../../../ui';
import { Color } from '../../../shared/styles/Color';
import { StyledErrorBar } from './VehicleDialog';

interface IVehicleDialogProps {
	isOpen: boolean;
	closeDialog: () => void;
	onDelete?: () => void;
	isDeleting: boolean;
	error: Error | undefined;
	closeButtonRef?: React.Ref<HTMLButtonElement>;
}

export const DeleteVehicleDialog = ({
	isOpen,
	closeDialog,
	onDelete,
	isDeleting,
	error,
	closeButtonRef,
}: IVehicleDialogProps) => {
	const { t } = useTranslation();
	const [errorBarVisible, setErrorBarVisible] = useState(!!error);

	useEffect(() => {
		setErrorBarVisible(!!error);
	}, [error]);

	return (
		<Dialog
			isOpen={isOpen}
			onDismiss={closeDialog}
			ariaLabel={t('account_vehicles_delete_vehicle')}
		>
			<DialogCloseButtonWrap>
				<StyledDialogCloseButton onClick={closeDialog} ref={closeButtonRef} />
			</DialogCloseButtonWrap>
			<StyledDialogMain>
				<h3>{t('account_vehicles_delete_vehicle')}</h3>
				<span>{t('account_vehicles_delete_vehicle_dialog_body')}</span>
				<StyledDeleteVehicleCta>
					<CancelButton type="button" onClick={closeDialog}>
						{t('account_vehicles_delete_vehicle_dialog_negative_button')}
					</CancelButton>
					<ConfirmDeleteButton
						type="button"
						onClick={onDelete}
						isLoading={isDeleting}
					>
						{t('account_vehicles_delete_vehicle_dialog_positive_button')}
					</ConfirmDeleteButton>
				</StyledDeleteVehicleCta>
			</StyledDialogMain>
			{errorBarVisible && (
				<StyledErrorBar onClick={() => setErrorBarVisible(false)}>
					{t('account_vehicles_save_error_label')}
					<CancelIcon aria-hidden />
				</StyledErrorBar>
			)}
		</Dialog>
	);
};

const DialogCloseButtonWrap = styled.div`
	padding: 24px 24px 0;
`;

const StyledDeleteVehicleCta = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledDialogMain = styled(DialogMain)`
	display: flex;
	flex-direction: column;
	gap: 18px;

	padding: 20px;
	margin-bottom: 50px;

	h3 {
		margin: 0;
	}
`;

const CancelButton = styled(TextButton)`
	color: ${Color.PrimaryDefault};
	padding: 0;

	&:hover {
		color: ${Color.PrimaryDefault};
	}
`;

const ConfirmDeleteButton = styled(ButtonWithLoader)``;
